

const ScatterPlot = ({ attr }) => {
    return (
        <div className="scatter-plot">
            {/* axis line */}
            <div className="axis-line" />
            {/* only two tick marks */}
            <div className="axis-tick zone-2" />
            <div className="axis-tick zone-1" />
            {/* zone labels */}
            <div className="axis-label zone-3">Zone 1</div>
            <div className="axis-label zone-2">Zone 2</div>
            <div className="axis-label zone-1">Zone 3</div>

            {/* dots */}
            <div className="dots-container">
            {attr.unique.map(({ pct, count, zone }, i) => {
                const baseSize = 10;
                const scaleFactor = 0.5; // adjust for visual effect
                const maxSize = 40;      // px
                const totalVotes = attr.zoneCount[1] + attr.zoneCount[2] + attr.zoneCount[3];

                // Calculate percent of total votes for this attribute
                const percent = (count / totalVotes) * 100;
                const size = Math.min(baseSize + percent * scaleFactor, maxSize);

                let bg;
                if (zone === 1) {
                bg = pct >= 76 ? "#56C271" : "#ffb100";
                } else if (zone === 2) {
                bg = "#DE6449";
                } else {
                bg = "indianred";
                }
                return (
                <div
                    key={i}
                    className="dot"
                    style={{
                    "--pct": `${pct}%`,
                    background: bg,
                    width: `${size}px`,
                    height: `${size}px`,
                    }}
                >
                    <div className="dot-tooltip">{count}</div>
                </div>
                );
            })}
            </div>
        </div>
    );
}

export default ScatterPlot;